<span class="spaced-wrapper" v-safe-html="getFilteredModel"></span>